import { COLORS } from 'Components/utils/color/colors';

export const cardBodyThemes = {
  default: {
    thText: '',
    thCta: 'uppercase',
    thCtaDefaultColor: COLORS.BLUE,
  },
  destination: {
    thText: '',
    thCta: 'uppercase',
    thCtaDefaultColor: COLORS.PRUNE,
  },
  landing: {
    thText: 'leading-tight',
    thCta: '',
    thCtaDefaultColor: COLORS.BLUE,
  },
  thumbnail: {
    thText: '',
    thCta: '',
    thCtaDefaultColor: COLORS.BLUE,
  },
};
